import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, HUECOS_TIPO } from "@/lib/api";

const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const CIERRE = { MADRID: ["14:30", "16:30"], ALCOBENDAS: ["14:00", "16:30"] };
const toMin = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
const toHm = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

export const tramos = ({ desde, hasta, cierreIni, cierreFin, minutos }) => {
  const out = [];
  const add = (a, b) => { for (let t = a; t + Math.min(minutos, 45) <= b; t += minutos) out.push([toHm(t), toHm(Math.min(t + minutos, b))]); };
  add(toMin(desde), toMin(cierreIni));
  add(toMin(cierreFin), toMin(hasta));
  return out;
};

export const GenerarHuecos = ({ open, centro, profs, onClose, onDone }) => {
  const [f, setF] = useState(null);
  useEffect(() => {
    if (open) setF({ profesional_id: profs[0]?.id || "", tipo: "optica", dias: [0, 1, 2, 3, 4], desde: "10:00", hasta: "20:15", cierreIni: CIERRE[centro][0], cierreFin: CIERRE[centro][1], minutos: 60 });
  }, [open, centro, profs]);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: k === "minutos" ? Number(e.target.value) : e.target.value });
  const lista = tramos(f);
  const crear = async () => {
    try {
      await Promise.all(f.dias.flatMap((dia) => lista.map(([inicio, fin]) => api.post("/huecos-tipo", { profesional_id: f.profesional_id, dia, inicio, fin, tipo: f.tipo, centro, nota: "" }))));
      toast.success(`${f.dias.length * lista.length} huecos creados`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="generar-huecos-dialog">
        <DialogHeader><DialogTitle className="font-[Outfit]">Crear huecos vacíos · {centro === "MADRID" ? "Madrid" : "Alcobendas"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3 text-[11px] font-semibold uppercase text-slate-500">
          <label>Profesional<select className="field-select mt-1" value={f.profesional_id} onChange={set("profesional_id")} data-testid="gen-prof">{profs.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}</select></label>
          <label>Tipo de hueco<select className="field-select mt-1" value={f.tipo} onChange={set("tipo")} data-testid="gen-tipo">{Object.entries(HUECOS_TIPO).filter(([k]) => !["comida", "no_agendar"].includes(k)).map(([k, t]) => <option key={k} value={k}>{t.label}</option>)}</select></label>
          <label>Desde<Input type="time" step="900" value={f.desde} onChange={set("desde")} className="mt-1" /></label>
          <label>Hasta<Input type="time" step="900" value={f.hasta} onChange={set("hasta")} className="mt-1" /></label>
          <label>Cierra a mediodía de<Input type="time" step="900" value={f.cierreIni} onChange={set("cierreIni")} className="mt-1" data-testid="gen-cierre-ini" /></label>
          <label>a<Input type="time" step="900" value={f.cierreFin} onChange={set("cierreFin")} className="mt-1" data-testid="gen-cierre-fin" /></label>
          <label>Duración<select className="field-select mt-1" value={f.minutos} onChange={set("minutos")} data-testid="gen-minutos"><option value={60}>Cada hora</option><option value={45}>Cada 45 minutos</option><option value={30}>Cada 30 minutos</option></select></label>
        </div>
        <div className="flex flex-wrap gap-2">
          {DIAS.map((d, i) => (
            <button key={d} type="button" onClick={() => setF({ ...f, dias: f.dias.includes(i) ? f.dias.filter((x) => x !== i) : [...f.dias, i] })} data-testid={`gen-dia-${i}`}
              className={`rounded-md border px-2.5 py-1 text-xs ${f.dias.includes(i) ? "bg-[#1E3A8A] text-white border-[#1E3A8A]" : "bg-white text-slate-600 border-slate-200"}`}>{d}</button>
          ))}
        </div>
        <p className="text-xs text-slate-500" data-testid="gen-preview">{lista.length} huecos por día: {lista.map((t) => t[0]).join(", ")}</p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={crear} disabled={!f.dias.length || !lista.length} data-testid="gen-submit" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Crear huecos</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
